// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type SearchIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from search.svg
 */
export default function SearchIcon(props: SearchIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="SearchIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M12 6a6 6 0 1 0-2.525 4.892l4.818 4.815.094.083a1 1 0 0 0 1.32-1.497L10.89 9.474A5.97 5.97 0 0 0 12 6M2 6a4 4 0 1 1 6.961 2.69l-.15.155-.16.152A3.98 3.98 0 0 1 6 10a4 4 0 0 1-4-4"
        />
      </g>
    </svg>
  );
}
